import { isRight } from 'fp-ts/Either';
import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { captureAndReportError } from '../utils/errorReporting';
import { useTRPC } from './useTRPC';

export interface UseDappPublishResult {
  isPublishing: boolean;
  handlePublish: () => Promise<void>;
}

export function useDappPublish(
  dappId: string | null,
  onPublished?: () => void,
): UseDappPublishResult {
  const trpc = useTRPC();
  const [isPublishing, setIsPublishing] = useState(false);

  const handlePublish = useCallback(async () => {
    if (!dappId) {
      return;
    }

    setIsPublishing(true);
    try {
      const result = await trpc.publishDapp.mutate({ dappId });
      if (isRight(result)) {
        toast.success('App published to the dApp Store');
        onPublished?.();
      } else {
        toast.error(result.left.message || 'Failed to publish app');
      }
    } catch (publishError) {
      captureAndReportError('Failed to publish app', publishError);
      toast.error('Failed to publish app');
    } finally {
      setIsPublishing(false);
    }
  }, [trpc, dappId, onPublished]);

  return {
    isPublishing,
    handlePublish,
  };
}
